import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {ApiRoutes} from '../../../../common/api-routes';
import {ProjectUnitShifts, Unit, ValidatedProjectUnitShifts} from '../../../../common/unit.model';
import {UnitViewModel} from '../components/add-edit-units/add-edit-units.component';

@Injectable({
  providedIn: 'root'
})
export class UnitsDataService {
  constructor(private http: HttpClient) {
  }

  retrieveUnits(projectId: string): Observable<Unit[]> {
    return this.http.get<Unit[]>(`${ApiRoutes.Units}/projects/${projectId}`);
  }

  saveUnits(projectId: string, units: UnitViewModel[]): Observable<Unit[]> {
    return this.http.put<Unit[]>(`${ApiRoutes.Units}/projects/${projectId}`, units);
  }

  retrieveProjectUnitShifts(projectId: string, weekEndingDate: string): Observable<ProjectUnitShifts> {
    return this.http.get<ProjectUnitShifts>(`${ApiRoutes.Units}/projects/${projectId}/weekEndingDate/${weekEndingDate}`);
  }

  saveProjectUnitShifts(projectId: string, weekEndingDate: string, projectUnitShifts: ProjectUnitShifts)
    : Observable<ProjectUnitShifts | ValidatedProjectUnitShifts> {
    return this.http.post<ProjectUnitShifts | ValidatedProjectUnitShifts>
    (`${ApiRoutes.Units}/projects/${projectId}/weekEndingDate/${weekEndingDate}`, projectUnitShifts);
  }

  retrieveProjectUnitShiftsWithId(projectId: string, weekEndingDate: string, unitId: string): Observable<ProjectUnitShifts> {
    return this.http.get<ProjectUnitShifts>(`${ApiRoutes.Units}/projects/${projectId}/weekEndingDate/${weekEndingDate}/unitSchedules/${unitId}`);
  }

  retrieveUnitSchedulesUpdateStatus(projectId: string): Observable<boolean> {
    return this.http.get<boolean>(`${ApiRoutes.Units}/projects/${projectId}/unitSchedulesUpdateStatus`);
  }
}
